import moment from 'moment';
const state = {
  routerList: [ // 是否显示菜单
    '/user',
    '/',
    '/home',
    '/unverified',
    '/invite'
  ],
  staffIds: [], // addstaff 页面缓存的ids
  outersIds: [], // addothers 页面缓存的ids
  hostId: [], // addhost 页面缓存的ids
  staffParentId: 0, // addstaff 页面缓存的ids
  hostParentId: 0, // addhost 页面缓存的ids
  roomData: '',
  submitForm: { // 需要提交的会议信息
    theme: '',
    visitDate: '',
    coOrganization: '',
    outsizeAttendeeCount: '',
    inners: [],
    outers: [],
    agendasList: [],
    materials: [],
    requires: [],
    requiresInfo: {
      dataForm: {},
      checkedList: []
    },
    organizer: '',
    organizerId: '',
    signType: 'ANYWAY_SIGN',
    signTime: '',
    starTime: '',
    endTime: '',
    meetingRoomId: '',
    meetingRoomName: '',
    ruleText: '手动签到/通行会议室门禁',
    ruleIndex: 0,
    meetingType: 'PRIVATE',
    meetingTypeText: '固定会议',
    pageStyle: 'blue',
    meetingTypeIndex: 0,
    organization: '',
    organizationId: ''
  },
  voucherApplicationForm: { // 申请卡券的form
    name: '',
    couponId: '',
    applyCount: '',
    receiptorId: '',
    applyReason: '',
    attachmentUrls: []
  },
  mealBookForm: {
    payText: '',
    zoneText: '',
    zoneIndex: '',
    payIndex: '',
    mealRuleId: '',
    bookingDate: '',
    payType: '',
    innerPersonIds: [],
    outerPersonNumber: 0,
    couponId: '',
    couponName: ''
  },
  bookingLimitTime: '',
  payType: '',
  floorInfo: {},
  inviteData: {
    once: true,
    accessDays: 1,
    reason: '',
    visitDate: '',
    carNumber: '',
    name: '',
    phone: '',
    retinues: [],
    floorName: ''
  },
  requiresInfo: {
    dataForm: {},
    checkedList: []
  },
  meetingDate: moment().format('YYYY-MM-DD'),
  selectStaffId: '',
  selectStaffParentId: '',
  selectStaffInfo: {
    name: ''
  },
  couponInfo: {},
  checkboxStaff: [],
  includeName: []
};

export default state;
